import B3LanguageService from './utils/lang'

const langLocales = B3LanguageService.create()

interface B3Tips {
  [x: string]: string
}

export interface B3Permissions {
  [x: string]: boolean
}
interface B3CheckoutConfig {
  routes?: {
    dashboard?: string
  }
  permissions?: B3Permissions
  tips?: B3Tips
}

interface PaymentMethodsFixedMap {
  [x: string]: any
}

export interface B3window extends Window {
  b3CheckoutConfig?: B3CheckoutConfig
}

export const routes = {
  dashboard: '/dashboard',
  newDashBoard: '/#/dashboard',
  ...(window as B3window).b3CheckoutConfig?.routes
}

export const permissions = {
  'address.save': true,
  'shipping.address.add': true,
  'shipping.singleAddress.allowAsBilling': true,
  'billing.address.add': true,
  ...(window as B3window).b3CheckoutConfig?.permissions
}

export const tips = {
  'b3.login.failed': 'Login Failed.',
  'b3.salesRep.notMasquerading': 'Please select a company.',
  'b3.salesRep.notQuoteMasquerading': 'The company assignment does not match the quote.',
  'b3.poinput.title': 'PO Number / Reference Number (Optional)',
  'b3.addresses.search': 'Search addresses',
  'b3.addresses.addressLabel': 'Address Label',
  'b3.addresses.enterNew': 'Enter a new address',
  'b3.addresses.select': 'Select an address',
  'b3.multiShipping.address.edit': 'Edit',
  'b3.multiShipping.address.remove': 'Remove',
  'b3.multiShipping.shipped.toAddress': 'can be shipped to another address.',
  'b3.poNumber.label': 'PO Number / Reference Number',
  'b3.label.optional': '(Optional)',
  'b3.IPPaymentComment.label': 'Payment comment',
  'b3.poNumber.required': 'PO Number / Reference Number is required.',
  'b3.field.required': 'Please Input',
  'b3.invoice.backList': 'Back to Invoices',
  'b3.payment.paymentButton': 'Make Payment',
  'b3.shipping.noAddress.notAddNewAddress.tip': 'Sorry, you have no shipping address to choose from, please go to your address book to create an address or contact your site admin.',
  'b3.billing.noAddress.notAddNewAddress.tip': 'Sorry, you have no billing address to choose from, please go to your address book to create an address or contact your site admin.',
  ...langLocales.tips,
  ...(window as any).b3CheckoutConfigTips
}

export const paymentMethodsFixedMap: PaymentMethodsFixedMap = {
  'quickbooks': 'qbmsv2',
  ...(window as any).b3CheckoutPayment
}